var exports = {
  "x": "x112a1f60--79300c--offer",
  "eh": "x112a1f60--79300c--room",
  "q9": "x112a1f60--79300c--price",
  "nf": "x112a1f60--79300c--link",
  "z8": "x112a1f60--79300c--props-count",
};

module.exports = exports;
